import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../context/i18nContext';
import Button from '../components/ui/Button';
import '../styles/AuthPages.css';

const LANGS = [
  { code: 'hu', label: 'Magyar' },
  { code: 'en', label: 'English' },
  { code: 'de', label: 'Deutsch' },
  { code: 'fr', label: 'Français' },
  { code: 'es', label: 'Español' },
  { code: 'nl', label: 'Nederlands' },
  { code: 'pl', label: 'Polski' },
];

const ForgotPasswordPage = () => {
  const { t, language } = useI18n();
  const [email, setEmail]     = useState('');
  const [lang, setLang]       = useState(language || 'hu');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError]     = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      const res = await fetch('/api/auth/forgot-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, lang }),
      });
      const data = await res.json();
      if (res.ok) setMessage(data.message || t('password.forgotSuccess'));
      else        setError(data.error || t('common.error'));
    } catch {
      setError(t('common.error'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page-container">
      <div className="auth-card">
        <div className="auth-logo">🔐</div>
        <h1 className="auth-title">{t('password.forgotTitle')}</h1>
        <p className="auth-subtitle">{t('password.forgotSubtitle')}</p>

        {message ? (
          <p className="auth-message success">✅ {message}</p>
        ) : (
          <form onSubmit={handleSubmit} className="auth-form">
            {error && <p className="auth-message error">❌ {error}</p>}

            <div className="form-group">
              <label>{t('auth.email')}</label>
              <input
                type="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                autoFocus
              />
            </div>

            <div className="form-group">
              <label>{t('common.language')}</label>
              <select
                value={lang}
                onChange={e => setLang(e.target.value)}
                className="form-select"
              >
                {LANGS.map(l => (
                  <option key={l.code} value={l.code}>{l.label}</option>
                ))}
              </select>
            </div>

            <Button type="submit" variant="solid" fullWidth disabled={loading}>
              {loading ? t('password.forgotSending') : t('password.forgotButton')}
            </Button>
          </form>
        )}

        <div className="auth-links">
          <Link to="/login">{t('auth.haveAccount')} {t('auth.loginHere')}</Link>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
